__turbopack_context__.v({
  "Switch": "app-switch-module__O2Wema__Switch",
  "Thumb": "app-switch-module__O2Wema__Thumb",
});
